'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("inputFilterRegexp", function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(function (inputValue) {
        //console.log("attrs" + attrs.inputFilterRegexp)
        //console.log(scope[attrs.inputFilterRegexp]);
        var transformedInput = inputValue.replace(scope[attrs.inputFilterRegexp], "");
        if (transformedInput !== inputValue) {
          //console.log("Modif : '"+ inputValue + "' -> '" + transformedInput + "'");
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/inputTypes/inputFilterRegexp.js
// module id = 2945
// module chunks = 13